import React from "react"
import { Link, graphql } from "gatsby"
import Img from "gatsby-image"

import Layout from "../components/layout"
import SEO from "../components/seo"
import { Card, Button, Image } from "react-bootstrap"
import Fade from "react-reveal/Fade"

const IndexPage = ({ data }) => (
  <Layout>
    <SEO title="Accueil" />
    <div className="container py-5">
      <div className="row">
        <div className="col-md-12 mb-5">
          <h2>Bienvenue</h2>
        </div>

        <div className="col-md-4 mb-3">
          <Img fluid={data.img1.childImageSharp.fluid} />
        </div>

        <Fade big>
          <div className="col-md-8">
            <p>
              Si vous êtes un particulier, je vous accueille en consultation
              individuelle à Senlis et je peux me déplacer à votre domicile. Si
              vous êtes{" "}
              <Link to="/entreprises/" title="Entreprises">
                une entreprise ou une collectivité
              </Link>
              , je suis à l’écoute de vos besoins pour apporter des solutions à
              vos collaborateurs.
              <br />
              <br />
              Cet espace vous est dédié. J’espère que vous y trouverez{" "}
              <Link to="/sophrologie/" title="Sophrologie">
                toutes les informations
              </Link>{" "}
              dont vous avez besoin et toutes les réponses aux questions que
              vous vous posez.
              <br />
              <br />
              Sentez-vous libre{" "}
              <Link to="/contact/" title="Contact">
                de m’écrire ou de m’appeler
              </Link>{" "}
              pour toute information complémentaire. Pour connaître mes
              coordonnées et me contacter,{" "}
              <Link to="/contact/" title="Contact">
                cliquez ici
              </Link>
              . Je m’engage à vous répondre dans les meilleurs délais.
              <br />
              <br />
              Je vous remercie de votre confiance et vous dis à bientôt&nbsp;!
              <br />
              <br />
              <a
                href="https://www.crenolib.fr/therapeute/sophrologue-et-hypnotherapeute/senlis/60300/5487-catherine_couten"
                target="_blank"
                rel="noreferrer"
              >
                <Button variant="secondary">Prendre rendez-vous</Button>
              </a>
            </p>
          </div>
        </Fade>
      </div>
      <Fade>
        <div className="row mt-3">
          <div className="col-lg-12">
            <Card className="text-center">
              <Card.Header>
                <strong>Qui suis-je ?</strong>
              </Card.Header>
              <Card.Body>
                <Image
                  width="200"
                  className="mb-3"
                  src={data.img2.publicURL}
                  rounded
                  alt="Catherine Couten"
                />
                <Card.Title>Catherine Couten</Card.Title>
                <Card.Text>
                  Je vous aide à prendre conscience de vos ressources et à
                  mobiliser vos capacités pour faire face aux difficultés du
                  quotidien.
                </Card.Text>
                <Link to="/votre-sophrologue/">
                  <Button variant="primary">En savoir plus</Button>
                </Link>
              </Card.Body>
            </Card>
          </div>
        </div>
      </Fade>
    </div>
  </Layout>
)

export const query = graphql`
  query {
    img1: file(relativePath: { eq: "IMG_4026.jpg" }) {
      relativePath
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    img2: file(relativePath: { eq: "cc-profil-400.jpg" }) {
      publicURL
    }
  }
`

export default IndexPage
